import config from 'Config'; /* eslint-disable-line */
import store from '../../';

const update = async (companyTicker, subsidiaryId) => {
  const authUser = store.getState().user;
  return fetch(
    `${config.apiUrl}/companies/${encodeURIComponent(companyTicker)}/subsidiary/${encodeURIComponent(subsidiaryId)}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: authUser.access_token,
        'grifin-user-key': authUser.publicKey,
      },
    },
  )
    .then(async (response) => {
      if (response.status !== 200 || false) {
        throw new Error(response.statusText);
      }
      return response;
    })
    .then(async (response) => {
      const json = await response.json();

      return { success: true, data: json };
    })
    .catch((error) => ({ error }));
};

export default update;
